import { mergeAttributes, PasteRule } from '@tiptap/core';
import { Url } from '@wix/da-url';
import { hashtagPasteRegex } from './utils/hashtagRegex';
import { hashtagMarkStarter, hashtagModification } from './prosePlugins';
import { Mark } from '@tiptap/react';
export const Hashtag = Mark.create({
    name: 'da-hashtag',
    inclusive: true,
    excludes: '_',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    addAttributes () {
        return {
            'data-hashtag': {
                default: null,
                parseHTML: (element)=>{
                    if (element && element.getAttribute('data-da-type') === this.name) {
                        return {
                            'data-hashtag': element.getAttribute('data-hashtag')
                        };
                    }
                    return false;
                },
                renderHTML: (attributes)=>{
                    const hashtag = attributes['data-hashtag'];
                    return hashtag ? {
                        'data-hashtag': hashtag,
                        href: Url.tagsPageLink(hashtag),
                        rel: 'noopener noreferrer',
                        target: '_blank'
                    } : {};
                }
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: `a[data-da-type="${this.name}"]`
            }
        ];
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            'a',
            mergeAttributes(this.options.HTMLAttributes, {
                'data-da-type': this.name
            }, HTMLAttributes),
            0
        ];
    },
    addPasteRules () {
        return [
            new PasteRule({
                find: hashtagPasteRegex,
                handler: ({ state, range, match })=>{
                    const [hashtag] = match !== null && match !== void 0 ? match : [];
                    if (hashtag) {
                        const { tr } = state;
                        tr.addMark(range.from, range.to, this.type.create({
                            'data-hashtag': hashtag.slice(1)
                        }));
                    }
                }
            })
        ];
    },
    addProseMirrorPlugins () {
        return [
            hashtagMarkStarter({
                type: this.type
            }),
            hashtagModification({
                type: this.type
            })
        ];
    }
});

//# sourceMappingURL=hashtag.js.map